import React from "react";
export default function Home() {



    function openPage(link) {
        window.open(link, "_blank")
    }

var link1 = 'https://youtube.com/grimmxiii';
var link2 = 'https://youtube.com/@grimlockxiii';
var link3 = 'https://www.reddit.com/user/GrimlockXIII/';
var link4 = 'https://soundcloud.com/the-xiii-one';
var link5 = 'https://gamebanana.com/members/1853325';
var link6 = 'https://psnprofiles.com/GGrimmXIII';
var link7 = 'https://discord.com/invite/uV48V4S9up';
var link8 = 'https://steamcommunity.com/id/grimmxiii/';
var link9 = 'https://ch.tetr.io/u/grimmxiii';
var link10 = 'https://github.com/GrimXIII';
var link11 = 'https://open.spotify.com/user/31edc4j5gu6mippcfd5ozyy7kjwq';
var link12 = 'https://www.instagram.com/grimmxiii/'




return (
    <>  
        <title>Grimm's Corner</title>
        <h1>
            GrimmXIII LinkTree
        </h1>
        <div className="main">
            <div className='linkBranch youtube' onClick={() => openPage(link1)}>
                <img className='imgLeft' src='youtube.png' alt='logo'/>
                <img className='imgRight' src='pfp/youtube1.png' alt='profile'/>
                <h2>YouTube</h2>
                <h3>@GrimmXIII</h3>
                <h4>Main YouTube Channel</h4>
                <h5>https://youtube.com/grimmxiii</h5>
            </div>

            <div className='linkBranch youtube' onClick={() => openPage(link2)}>
                <img className='imgLeft' src='youtube.png' alt='logo'/>
                <img className='imgRight' src='pfp/youtube2.png' alt='profile'/>
                <h2>YouTube</h2>
                <h3>@GrimlockXIII</h3>
                <h4>Secondary YouTube channel</h4>
                <h5>https://youtube.com/@grimlockxiii</h5>
            </div>

            <div className='linkBranch reddit'  onClick={() => openPage(link3)}>
                <img className='imgLeft' src='reddit.png' alt='logo'/>
                <img className='imgRight' src='pfp/reddit.png' alt='profile'/>
                <h2>Reddit</h2>
                <h3>u/GrimlockXIII</h3>
                <h4>Official Reddit Account</h4>
                <h5>https://www.reddit.com/user/GrimlockXIII/</h5>
            </div>

            <div className='linkBranch soundcloud' onClick={() => openPage(link4)}>
                <img className='imgLeft' src='soundcloud.png' alt='logo'/>
                <img className='imgRight' src='pfp/soundcloud.png' alt='profile'/>
                <h2>SoundCloud</h2>
                <h3>Grimlock XIII</h3>
                <h4>Abandoned SoundCloud account (Since around 2020, this account make me unhappy :(</h4>
                <h5>https://soundcloud.com/the-xiii-one</h5>
            </div>

            <div className='linkBranchInvert gamebanana' onClick={() => openPage(link5)}>
                <img className='imgLeft' src='gamebanana.png' alt='logo'/>
                <img className='imgRight' src='pfp/gamebanana.png' alt='profile'/>
                <h2>Gamebanana</h2>
                <h3>Grimlock XIII</h3>
                <h4>Official Gamebanana Account (Ehhh...)</h4>
                <h5>https://gamebanana.com/members/1853325</h5>
            </div>

            <div className='linkBranch playstation' onClick={() => openPage(link6)}>
                <img className='imgLeft' src='playstation.png' alt='logo'/>
                <img className='imgRight' src='pfp/playstation.png' alt='profile'/>
                <h2>PlayStation</h2>
                <h3>GGrimmXIII</h3>
                <h4>Official PlayStation Account</h4>
                <h5>https://psnprofiles.com/GGrimmXIII</h5>
            </div>

            <div className='linkBranch spotify' onClick={() => openPage(link11)}>
                <img className='imgLeft' src='spotify.png' alt='logo'/>
                <img className='imgRight' src='pfp/grimlock1.png' alt='profile'/>
                <h2>Spotify</h2>
                <h3>GrimmXIII</h3>
                <h4>Spotify Profile (No uploads yet :)</h4>
                <h5>https://open.spotify.com/user/31edc4j5gu6mippcfd5ozyy7kjwq</h5>
            </div>

            <div className='linkBranch discord' onClick={() => openPage(link7)}>
                <img className='imgLeft' src='discord.png' alt='logo'/>
                <img className='imgRight' src='pfp/discord.png' alt='profile'/>
                <h2>Discord</h2>
                <h3>Public Server</h3>
                <h4>Official GrimmXIII Discord Server invite!</h4>
                <h5>https://discord.com/invite/uV48V4S9up</h5>
            </div>

            <div className='linkBranch steam' onClick={() => openPage(link8)}>
                <img className='imgLeft' src='steam.png' alt='logo'/>
                <img className='imgRight' src='pfp/steam.png' alt='profile'/>
                <h2>Steam</h2>
                <h3>GrimmXIII</h3>
                <h4>Official Steam Profile</h4>
                <h5>https://steamcommunity.com/id/grimmxiii/</h5>
            </div>

            <div className='linkBranch tetrio' onClick={() => openPage(link9)}>
                <img className='imgLeft' src='tetr.png' alt='logo'/>
                <img className='imgRight' src='pfp/tetr.png' alt='profile'/>
                <h2>TETR.IO</h2>
                <h3>GRIMMXIII</h3>
                <h4>Official TETR.IO Account</h4>
                <h5>https://ch.tetr.io/u/grimmxiii</h5>
            </div>

            <div className='linkBranch instagram' onClick={() => openPage(link12)}>
                <img className='imgLeft' src='instagram.png' alt='logo'/>
                <img className='imgRight' src='pfp/grimlock1.png' alt='profile'/>
                <h2>Instagram</h2>
                <h3>GrimmXIII</h3>
                <h4>Private Instagram Profile</h4>
                <h5>https://www.instagram.com/grimmxiii/</h5>
            </div>

            <div className='linkBranchInvert github' onClick={() => openPage(link10)}>
                <img className='imgLeft' src='github.png' alt='logo'/>
                <img className='imgRight' src='pfp/github.png' alt='profile'/>
                <h2>GitHub</h2>
                <h3>GrimXIII</h3>
                <h4>Official GitHub Account</h4>
                <h5>https://github.com/GrimXIII</h5>
            </div>

            <div className='linkBranchInvert x'>
                <img className='imgLeft' src='x.png' alt='logo'/>
                <img className='imgRight' src='pfp/tetr.png' alt='profile'/>
                <h2>X / Twitter</h2>
                <h3>[Err 404]</h3>
                <h4>Official Twitter Account</h4>
                <h5>[Err 404]</h5>
            </div>
        </div>
    </>
    );
}
